
const digest = '354ac69248cec34df3c52cbb6f097e0b761259acc8bb51e609b41d2bc147b8ee';
const css = `._attachment_vsvkf_1 {
  display: inline-block;
  padding: 1px 3px;
}
._attachment_vsvkf_1 ._icon_vsvkf_5 {
  font-size: 22px;
  color: #666;
}
._attachment_vsvkf_1._iconLeft_vsvkf_9 ._icon_vsvkf_5 {
  padding-right: 5px;
}
._attachment_vsvkf_1._iconAbove_vsvkf_12 {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}
._attachment_vsvkf_1._iconAbove_vsvkf_12 ._icon_vsvkf_5 {
  padding-bottom: 5px;
}
._attachment_vsvkf_1 ._name_vsvkf_20 {
  user-select: none;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"attachment":"_attachment_vsvkf_1","icon":"_icon_vsvkf_5","iconLeft":"_iconLeft_vsvkf_9","iconAbove":"_iconAbove_vsvkf_12","name":"_name_vsvkf_20"};
export { css, digest };
  